import { IAttrValue, IconCode } from "@multiweb/types/contracts";
import { EnumUtils } from "Global/Base/Utils/EnumUtils";
import { AttrValueReader } from "OW.Remoting/Remoting/AttrValueReader";
import { ItemTemplate } from "../ItemTemplate";

export class IconTemplate extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        item.innerHTML = "";
        item.className = "icon-column";
        const data = AttrValueReader.read(this._getDataFromSet(dataSet));

        if (data !== null) {
            if (EnumUtils.hasEnumValue(IconCode, data.toString().trim())) {
                item.classList.add("Icon", data.toString().trim());
            } else {
                item.textContent = data;
            }
        }
    }
}
